module.exports = __webpack_public_path__ + "img/drip-feed-blue.492195d2.svg";